import {
  BillingPortalInput,
  BillingPortalResult,
  CreditBalance,
  CreditPack,
  CreditService,
  CreditTransaction,
  GetCreditTransactionsInput,
  PurchaseCreditsInput,
  PurchaseCreditsResult,
} from '@services';
import { makeAutoObservable, runInAction } from 'mobx';

class CreditStore {
  balance: CreditBalance | null = null;
  creditPacks: CreditPack[] = [];
  transactions: CreditTransaction[] = [];
  transactionTotal: number = 0;
  loading: boolean = false;
  submitLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getBalance() {
    this.setLoading(true);
    try {
      const result = await CreditService.getBalance();
      runInAction(() => {
        this.balance = result;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async getCreditPacks() {
    this.setLoading(true);
    try {
      const result = await CreditService.getCreditPacks();
      runInAction(() => {
        this.creditPacks = result;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async getTransactions(input: GetCreditTransactionsInput) {
    this.setLoading(true);
    try {
      const result = await CreditService.getTransactions(input);
      runInAction(() => {
        this.transactions = result.items;
        this.transactionTotal = result.totalCount;
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async purchaseCredits(input: PurchaseCreditsInput): Promise<PurchaseCreditsResult | undefined> {
    this.setSubmitLoading(true);
    try {
      const result = await CreditService.purchaseCredits(input);
      this.setSubmitLoading(false);
      return result;
    } catch (error) {
      this.setSubmitLoading(false);
      console.error(error);
      throw error;
    }
  }

  async getBillingPortalUrl(input: BillingPortalInput): Promise<BillingPortalResult | undefined> {
    this.setSubmitLoading(true);
    try {
      const result = await CreditService.getBillingPortalUrl(input);
      this.setSubmitLoading(false);
      return result;
    } catch (error) {
      this.setSubmitLoading(false);
      console.error(error);
      throw error;
    }
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  setSubmitLoading = (value: boolean) => {
    runInAction(() => {
      this.submitLoading = value;
    });
  };

  clear() {
    runInAction(() => {
      this.balance = null;
      this.creditPacks = [];
      this.transactions = [];
      this.transactionTotal = 0;
    });
  }
}

export default CreditStore;
